import Icon from 'veui/components/Icon'
import { IconListOrdered } from 'dls-icons-vue'

Icon.register('list-ordered', IconListOrdered)
